import RankBase from "../RankBase";
import Notice from "../Notice";

const PLACE_RANK_TYPE = 'ST001'

const notices = [
    { text: '무료 회원은 3개까지 무료 등록이 가능합니다. (회원정보 사용 슬롯 참고)', style: { color: 'red' } },
    { text: '플레이스 주소는 https://m.place.naver.com/place/ 로 시작하는 주소를넣어주세요.' },
    { text: '플레이스 URL주소 입력시 업체명이 변경 되어도 순위체크가 가능합니다.' },
    { text: '매일 순위 체크는 13시 부터 순차적으로 순위 업데이트 진행 합니다.' },
    { text: '순위 이력은 최근 3개월 내역까지 저장이되며, 3개월 경과건은 순차적으로 삭제 될 수 있습니다.' },
    { text: '순위는 300위까지 체크됩니다.' },
    { text: '순위 표시에 나오는 표시항목은 순위, 저장하기갯수, 블로그갯수, 방문자리뷰갯수 입니다.' },
    { text: '블 = 블로그 갯수 / 방 = 방문자 갯수' }
]

const PlaceNotice = () => (<Notice notices={notices} /> );
    
const PlaceRank = props => {
    return (
        <RankBase notice={PlaceNotice} type={PLACE_RANK_TYPE} />
    )
}

export default PlaceRank;
